const gradientSliderSections = document.querySelectorAll(".gradient-cards");
console.log("gradient");

gradientSliderSections.forEach((section) => {
  const sliderDiv = section.querySelector(".gradient-slider");
  const slides = section.querySelectorAll("ul.gradient-slider > li");
  console.log(section.querySelectorAll("ul.gradient-slider "));

  const controlsContainer = section.querySelector(".gradient-slider-controls");
  const progressBar = section.querySelector(
    ".progress-bar > .progress"
  );
  console.log("slider", slides.length);

  if (sliderDiv && slides.length > 0) {
    const overflowSlider = tns({
      container: sliderDiv,
      autoplay: false,
      controls: true,
      nav: false,
      loop: false,
      autoplayButtonOutput: false,
      controlsContainer: controlsContainer || null,
      speed: 500,
      gutter: 8,
      fixedWidth: 234,
      responsive: {
        1024: {
          disable: true,
        },
      },
    });

    if (progressBar) {
      const totalSlides = slides.length;

      const updateProgressBar = () => {
        const info = overflowSlider.getInfo();
        const currentIndex = info.index + 1; // 0-based index of current slide
        const visibleItems = info.items;
        const maxIndex = info.slideCount + 1 - visibleItems;

        // Calculate progress (0–100%)
        const percent = Math.min((currentIndex / maxIndex) * 100, 100);
        progressBar.style.width = `${percent}%`;
      };

      // Initial state
      updateProgressBar();

      // Hook into events
      overflowSlider.events.on("indexChanged", updateProgressBar);
    }
  }
});
